/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedControlledHeadingWrapper_itemSearch = {
    readonly meta: {
        readonly subHeader: string | null;
    } | null;
    readonly " $refType": "SbSharedControlledHeadingWrapper_itemSearch";
};
export type SbSharedControlledHeadingWrapper_itemSearch$data = SbSharedControlledHeadingWrapper_itemSearch;
export type SbSharedControlledHeadingWrapper_itemSearch$key = {
    readonly " $data"?: SbSharedControlledHeadingWrapper_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedControlledHeadingWrapper_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedControlledHeadingWrapper_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "meta",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "subHeader",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'cb8487198d9bdb02a1467175dfae95fc';
export default node;
